import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-external-redirect',
  template: `<p>Redirecting ...</p>`
})
export class ExternalRedirectComponent implements OnInit {
  targetUrl = '';

  constructor(private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    this.targetUrl = this.route.snapshot.data['externalUrl'] ?? '';

    if (this.targetUrl && isPlatformBrowser(this.platformId)) {
      window.location.replace(this.targetUrl);
    }
  }
}
